import React from 'react';
import { PropTypes as PT } from 'prop-types';
import _compact from 'lodash/compact';
import SVG from 'react-inlinesvg';
import personIcon from '@lifesize/ux-assets/vectors/svgIcons/person.svg';
import { PREVIEW_VIDEO_ID } from 'constants/InCall/InCallVideo';
import classes from './PreviewVideo.module.scss';

const PreviewVideo = ({ defaultVideoSetting }) => {
  const videoMuted = defaultVideoSetting === false;
  const videoMuteClasses = _compact([
    classes.mutedVideo,
    videoMuted ? classes.visible : ''
  ]).join(' ');

  return (
    <div className={classes.videoContainer}>
      <div className={videoMuteClasses} >
        <SVG src={personIcon} data-testid="personIcon" />
      </div>
      <video id={PREVIEW_VIDEO_ID} />
    </div>
  );
};

PreviewVideo.propTypes = {
  defaultVideoSetting: PT.bool
};

export default PreviewVideo;
